














import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import AppealsEmail from "./AppealsEmail.vue";
@Component({
    components: {AppealsEmail}
})
export default class ContactCustomerServices extends Vue {
    
    @Prop() bookingRef: string;
    
    mounted() {
        history.replaceState(null, 'Contact Us - TrainSplit Refunds', '/Home/Disruption/Finished');
    }
    
    get appealsEmail() {
        return window.getAppealsEmail();
    }
}
